'use client';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import type { SearchChipTab } from '@repo/ui/src/components/SearchChips';
import type { SearchOverview } from '@hooks/search/useSearchOverview';
import SearchSectionRow from './_SearchSectionRow';
import { SearchResultType } from './_SearchResultCard';

interface Props {
  overview: SearchOverview;
  isFetching: boolean;
  contentTabs: Array<SearchChipTab>;
  onViewAll: (type: string) => void;
}

const SUPPORTED_CARD_TYPES: Array<string> = ['Product', 'Recipe', 'Learn'];

const EMPTY_SECTION = { nbHits: 0, results: [] };

const SearchAllView = ({ overview, isFetching, contentTabs, onViewAll }: Props) => {
  const { t } = useTranslation();
  const cardTabs = contentTabs
    .filter((tab) => SUPPORTED_CARD_TYPES.includes(tab.searchType))
    .sort((a, b) => (a.searchType === 'Recipe' ? -1 : b.searchType === 'Recipe' ? 1 : 0));

  if (cardTabs.length === 0) {
    return (
      <p className="mt-8 text-center text-neutral-500">
        {t('search.noResults', undefined, { default: 'No results found.' })}
      </p>
    );
  }

  return (
    <div>
      {cardTabs.map((tab) => (
        <SearchSectionRow
          key={tab.searchType}
          searchType={tab.searchType as SearchResultType}
          label={tab.tabName}
          data={overview[tab.searchType] ?? EMPTY_SECTION}
          isFetching={isFetching}
          onViewAll={onViewAll}
        />
      ))}
    </div>
  );
};

export default SearchAllView;
